// extracted by mini-css-extract-plugin
export default {"uniqueTabs":"ManageContestsTabComponent_uniqueTabs__3TpbH","uniqueTab":"ManageContestsTabComponent_uniqueTab__2IgUB","active":"ManageContestsTabComponent_active__PJAZM"};